var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PersonInterfaceUser component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPersonInterfaceUser extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10751_4844)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.09229 5.72865C4.09229 3.05561 6.25922 0.888672 8.93226 0.888672C11.6053 0.888672 13.7722 3.05561 13.7722 5.72865C13.7722 8.40169 11.6053 10.5686 8.93226 10.5686C6.25922 10.5686 4.09229 8.40169 4.09229 5.72865ZM8.93226 2.38867C7.08765 2.38867 5.59229 3.88403 5.59229 5.72865C5.59229 7.57326 7.08765 9.06862 8.93226 9.06862C10.7769 9.06862 12.2722 7.57326 12.2722 5.72865C12.2722 3.88403 10.7769 2.38867 8.93226 2.38867ZM20.1676 11.9784C20.4605 11.6856 20.9353 11.6856 21.2282 11.9785L22.9606 13.7108C23.2535 14.0037 23.2535 14.4786 22.9606 14.7715C22.6677 15.0644 22.1928 15.0644 21.8999 14.7715L20.6979 13.5694L19.1156 15.1516L20.2919 16.324C20.5853 16.6164 20.586 17.0913 20.2936 17.3847C20.0012 17.678 19.5263 17.6788 19.233 17.3864L18.055 16.2123L16.4652 17.802C16.7833 18.3295 16.9663 18.9475 16.9663 19.6083C16.9663 21.5429 15.398 23.111 13.4635 23.111C11.529 23.111 9.96069 21.5429 9.96069 19.6083C9.96069 17.6738 11.5289 16.1055 13.4635 16.1055C14.1942 16.1055 14.8726 16.3292 15.434 16.7119L17.51 14.636L17.5228 14.6229L17.5377 14.6083L20.1676 11.9784ZM13.4635 17.6055C12.3574 17.6055 11.4607 18.5022 11.4607 19.6083C11.4607 20.7144 12.3573 21.611 13.4635 21.611C14.5696 21.611 15.4663 20.7144 15.4663 19.6083C15.4663 18.5022 14.5696 17.6055 13.4635 17.6055ZM8.63478 13.8394C9.7538 13.7865 10.868 14.018 11.8733 14.5124C12.245 14.6951 12.6945 14.542 12.8773 14.1703C13.0601 13.7986 12.9069 13.3491 12.5352 13.1663C11.3024 12.5601 9.93611 12.2762 8.56384 12.3411C7.1916 12.4061 5.8582 12.8178 4.68818 13.5378C3.5182 14.2578 2.54977 15.2626 1.87337 16.4583C1.19699 17.6541 0.83466 19.0017 0.820312 20.3755V21.2702C0.820312 21.6845 1.1561 22.0202 1.57031 22.0202H7.56894C7.98316 22.0202 8.31894 21.6845 8.31894 21.2702C8.31894 20.856 7.98316 20.5202 7.56894 20.5202H2.32031V20.3874C2.33264 19.2683 2.62803 18.1709 3.17897 17.1969C3.73054 16.2218 4.52026 15.4024 5.47434 14.8153C6.42843 14.2282 7.51577 13.8924 8.63478 13.8394Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_10751_4844">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPersonInterfaceUser.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonInterfaceUser.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonInterfaceUser.prototype, "size", void 0);
if (customElements.get('cat-icon-person-interface-user') === undefined) {
    customElements.define('cat-icon-person-interface-user', BlocksIconPersonInterfaceUser);
}
